import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import ReactSVG from 'react-svg';
import logo from 'images/logo.svg';

class AppHeader extends Component {
  render() {
    return (
      <div id="AppHeader" className="AppHeader  bgc:light-pewter  z:3 p:r  select:n">

        <div className="wrap:m m-x:a  d:f ai:s  bsh:s">

          <div className="AppHeader__Logo">
            <NavLink className="d:b  p:xs p-x:s  bgc:cinnibar" exact to="/">
              <ReactSVG
                path={logo}
                className="AppLogo"
                style={{
                  fill: 'white',
                  width: '1.5rem',
                  marginBottom: '-0.25rem'
                }}
              />
            </NavLink>
          </div>

          <div className="AppHeader__Nav  d:f flg:1 p-x:xs  bgc:white">
            <nav className="d:f fld:r ai:c as:s  ts:small fw:5 c:dark-pewter">
              <NavLink className="p:xs hv(c:black)" exact to="/">Pokemon</NavLink>
              <NavLink className="p:xs hv(c:black)" to="/moves/">Moves</NavLink>
              <NavLink className="p:xs hv(c:black)" to="/raids/">Raids</NavLink>
            </nav>
          </div>

          <div className="AppHeader__Aside  d:f as:s ai:c p-x:s  bgc:white c:pewter">
            
          </div>

        </div>

      </div>
    );
  }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/AppHeader.js